module.exports = __webpack_public_path__ + "static/media/blackLogo.cac8addf.png";